export default 'default';
export const SOLAR = 'solar';
